import apiClient from './meta-client';
import type {
    PageGroup,
    CreatePageGroupInput,
    UpdatePageGroupInput,
} from '@/pages/Meta/Connection/types/meta.types';

// ====================================
// Page Groups — agrupamento página→app pra roteamento de envio.
// Uma página pode pertencer a 0 ou 1 grupo. Cada grupo aponta pra 1 app.
// No envio, o backend resolve o app de cada página pelo grupo (fallback:
// primeiro token da página em chatmeta_page_tokens).
// ====================================

export const getPageGroups = async (): Promise<PageGroup[]> => {
    const response = await apiClient.get<PageGroup[]>('/meta/page-groups');
    return response.data;
};

export const getPageGroup = async (id: number): Promise<PageGroup> => {
    const response = await apiClient.get<PageGroup>(`/meta/page-groups/${id}`);
    return response.data;
};

export const createPageGroup = async (data: CreatePageGroupInput): Promise<PageGroup> => {
    const response = await apiClient.post<PageGroup>('/meta/page-groups', data);
    return response.data;
};

export const updatePageGroup = async (id: number, data: UpdatePageGroupInput): Promise<PageGroup> => {
    const response = await apiClient.put<PageGroup>(`/meta/page-groups/${id}`, data);
    return response.data;
};

export const deletePageGroup = async (id: number): Promise<{ message: string }> => {
    const response = await apiClient.delete<{ message: string }>(`/meta/page-groups/${id}`);
    return response.data;
};
